import React, { useState, useEffect, useRef } from "react";
import "./other.css";
import bilgi from "../../assets/bilgi.jpg";
import romantic from "../../assets/romantic.mp3";

const Other = () => {
  const [step, setStep] = useState(1);
  const [isRejected, setIsRejected] = useState(false);
  const [noHoverCount, setNoHoverCount] = useState(0);
  const [noBtnPos, setNoBtnPos] = useState({ top: 0, left: 0 });
  const audioRef = useRef(null);

  const playAudio = () => {
    if (audioRef.current) {
      audioRef.current.play().catch((e) => {
        console.warn("Autoplay prevented:", e);
      });
    }
  };

  const handleYes = () => {
    if (step === 1) playAudio(); // sadece ilk "evet"te başlasın
    setStep(step + 1);
  };

  const handleNoClick = () => {
    if (step === 2 && noHoverCount >= 4) {
      setIsRejected(true);
      setStep(99);
    } else {
      setIsRejected(true);
      setStep(99);
    }
  };

  const handleNoHover = () => {
    if (step === 2 && noHoverCount < 3) {
      const randomTop = Math.floor(Math.random() * 60);
      const randomLeft = Math.floor(Math.random() * 60);
      setNoBtnPos({ top: randomTop, left: randomLeft });
      setNoHoverCount(noHoverCount + 1);
    } else if (step === 2 && noHoverCount < 4) {
      setNoHoverCount(noHoverCount + 1);
    }
  };

  useEffect(() => {
    if (step === 3 || step === 99) {
      const interval = setInterval(() => {
        const emoji = document.createElement("div");
        emoji.className = "floating-emoji";
        emoji.innerText = step === 3 ? "❤️" : "😠";
        emoji.style.left = `${Math.random() * 100}vw`;
        document.body.appendChild(emoji);
        setTimeout(() => emoji.remove(), 4000);
      }, 200);
      return () => clearInterval(interval);
    }
  }, [step]);

  return (
    <div className="container2">
      <audio ref={audioRef} src={romantic} loop preload="auto" />
      {step === 1 && (
        <div className="fade-in">
          <h1>HAYATIMIN AŞKININ KİM OLDUĞUNU ÖĞRENMEK İSTİYOIR MUSUN ?</h1>
          <div className="button-group2">
            <button className="button2" onClick={handleYes}>Evet</button>
            <button className="button2 no-button2" onClick={handleNoClick}>Hayır</button>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="fade-in">
   <h1>
  Bunu öğrenmek için beni gerçekten seviyor olman lazım.<br />
  <span style={{ color: "#e91e63", fontWeight: "bold" }}>
    Beni gerçekten seviyor musun?
  </span>
</h1>

          <div className="button-group2">
            <button className="button2" onClick={handleYes}>Evet</button>
            <button
              className="button2 no-button2 moving-no"
              onClick={handleNoClick}
              onMouseEnter={handleNoHover}
              style={{
                position: noHoverCount < 4 ? "absolute" : "static",
                top: `${noBtnPos.top}%`,
                left: `${noBtnPos.left}%`,
              }}
            >
              Hayır
            </button>
          </div>
        </div>
      )}

      {step === 3 && (
        <div className="love-container">
          <img className="love-image" src={bilgi} alt="Love" />
        </div>
      )}

      {step === 99 && isRejected && (
        <div className="fade-in angry-container">
          <h1>Seni sevmiyorum o zaman 😠</h1>
        </div>
      )}
    </div>
  );
};

export default Other;
